export default [{
    path: 'monitoringConfiguration',
    redirect: '/monitoringConfiguration/Dictionary',
    children: [{
        path: '/monitoringConfiguration/Dictionary',
        meta: {
            title: "字典管理",
            name: 'Dictionary',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/monitoringConfiguration/Dictionary.vue')
        }
    },{
        path: '/monitoringConfiguration/Alert',
        meta: {
            title: "告警配置",
            name: 'Alert',
            keepAlive: true
        },
        components: {
            mains: () => import('../views/monitoringConfiguration/Alert.vue')
        }
    } ]
}]